export default __webpack_public_path__ + "ad432c13d61eb687e73987b7078c313d.jpg";